/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserAlertNotificationSetting } from '../../models/user-alert-notification-setting';
import { UserAlertNotificationSettingDto } from '../../models/user-alert-notification-setting-dto';

export interface AddSetting_3$Params {
      body: UserAlertNotificationSettingDto
}

export function addSetting_3(http: HttpClient, rootUrl: string, params: AddSetting_3$Params, context?: HttpContext): Observable<StrictHttpResponse<UserAlertNotificationSetting>> {
  const rb = new RequestBuilder(rootUrl, addSetting_3.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserAlertNotificationSetting>;
    })
  );
}

addSetting_3.PATH = '/api/user/notification/alert/setting';
